import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { StandardComponent } from '../../../standardComponentScore/standardUser'
import { getModelLists } from '../../store/thunk'
import { HighLight } from './components/hightLight'
import { PremiumComponent } from './components/premiumUser'
import classes from './index.module.scss'

export const BottomComponent = ({ isAllow }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getModelLists())
  }, [locale])

  return (
    <>
      {isAllow ? (
        <div>
          <Element
            className={classes.hightLightMain}
            style={{
              borderColor: '#E5E5E8',
            }}
          >
            <HighLight />
          </Element>
          <PremiumComponent />
        </div>
      ) : (
        <div>
          <StandardComponent />
        </div>
      )}
    </>
  )
}
